import React from 'react';
import styled from 'styled-components';
import { SeatMapSlot, SeatMapSlotResource, ResourceCategory } from '@src/core/buyerApiClient';
import { AVAILABLE_STATUS, isValidStatus, statusColors } from '@src/common/seatMaps';

interface SlotProps {
  slot: SeatMapSlot;
  onClick: (slot: SeatMapSlotResource) => void;
  sizeMultiplier: number;
  status: string;
  category: ResourceCategory;
}

const Slot = (props: SlotProps) => {
  const { slot, onClick, sizeMultiplier, status, category } = props;
  const { id, shapeType, rect, circle, resource } = slot;

  const getColor = () => {
    if (status === AVAILABLE_STATUS) {
      return category.color;
    }

    return statusColors[status];
  };

  const makeShapeCss = (width: number, height: number, top: number, left: number, type: string, angle: number) => ({
    left: `${Math.round(left * sizeMultiplier)}px`,
    top: `${Math.round(top * sizeMultiplier)}px`,
    width: `${Math.round(width * sizeMultiplier)}px`,
    height: `${Math.round(height * sizeMultiplier)}px`,
    transform: type === 'circle' ? 'none' : `rotate(${Math.round(angle)}deg)`,
    transformOrigin: type === 'circle' ? 'none' : 'top left',
    borderColor: getColor(),
    backgroundColor: `${getColor()}aa`,
    cursor: isValidStatus(status) ? 'pointer' : 'default',
    borderRadius: type === 'circle' ? '50%' : '0%',
  });

  const getStyle = () => {
    const top = shapeType === 'rect' ? rect!.top : circle!.top;
    const left = shapeType === 'rect' ? rect!.left : circle!.left;
    const width = shapeType === 'rect' ? rect!.width : circle!.radius * 2;
    const height = shapeType === 'rect' ? rect!.height : circle!.radius * 2;
    const angle = shapeType === 'rect' ? rect!.angle : 0;

    return makeShapeCss(width, height, top, left, shapeType, angle);
  };

  return (
    <Shape
      key={id}
      title={resource!.name}
      style={getStyle()}
      onClick={() => {
        onClick(resource!);
      }}
      data-cy={isValidStatus(status) ? 'available_slot' : 'unavailable_slot'}
    />
  );
};

const Shape = styled.div`
  position: absolute;
  border: 2px solid;
  transition: background-color 0.1s, border-color 0.1s;
  cursor: pointer;
`;

export default Slot;
